import styled, { css } from 'styled-components';
import { grey3, white, mainTextColor } from 'constants/variables';
import toRem from 'utils/toRem';
import CallToAction from 'contentful/shared/call_to_action';
import ContentfulImageRenderer from './image_renderer';

const GridItem = ({
  image,
  title,
  description,
  callToAction,
  alignment,
  containerColor,
  isCard,
  hasIcons,
}) => (
  <Card
    className="grid-item"
    isCard={isCard}
    containerColor={containerColor}
    hasIcons={hasIcons}
    alignment={alignment}>
    {image && !!Object.keys(image).length && (
      <div className="grid-item__image">
        <ContentfulImageRenderer image={image} />
      </div>
    )}
    <div className="grid-item__content">
      <Heading>{title}</Heading>
      {description && <p>{description}</p>}
    </div>
    {callToAction && (
      <CallToAction
        id={callToAction.sys.id}
        content={callToAction.fields}
        newTab
      />
    )}
  </Card>
);

const Card = styled.div`
  display: grid;
  gap: ${toRem(16)};
  align-content: flex-start;

  ${({ isCard, containerColor, hasIcons }) =>
    isCard &&
    css`
      background-color: ${containerColor === 'white' ? grey3 : white};
      color: ${containerColor === 'white' ? 'inherit' : mainTextColor};
      padding: ${toRem(24)};

      .grid-item__image {
        margin: ${!hasIcons ? `${toRem(-24)} ${toRem(-24)} 0` : '0'};
      }
    `}

  ${({ hasIcons, alignment }) =>
    hasIcons &&
    css`
      grid-template-columns: ${alignment === 'left' ? '32px 1fr' : 'auto'};

      .grid-item__image {
        justify-self: center;
        max-width: 32px;
      }

      .contentful__container__call_to_action {
        grid-column: ${alignment === 'left' ? 'span 2' : 'auto'};
      }
    `}

  img {
    width: 100%;
    height: auto;
  }

  .grid-item__content {
    display: grid;
    gap: ${toRem(16)};

    > * {
      margin: 0;
    }
  }

  .contentful__container__call_to_action {
    align-self: end;
  }

  .cef-btn {
    width: 100%;
    min-width: unset;
  }
`;

const Heading = styled.h3`
  font-size: ${toRem(24)};
  line-height: ${toRem(28)};
  color: inherit;
  margin-block: 0 ${toRem(16)};
`;

export default GridItem;
